/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoDrawItemDetailDrawItemRewardDetailData model module.
 * @module model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData
 * @version 1.0
 */
class EventsControllerDtoDrawItemDetailDrawItemRewardDetailData {
    /**
     * Constructs a new <code>EventsControllerDtoDrawItemDetailDrawItemRewardDetailData</code>.
     * @alias module:model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData
     */
    constructor() { 
        
        EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoDrawItemDetailDrawItemRewardDetailData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoDrawItemDetailDrawItemRewardDetailData} The populated <code>EventsControllerDtoDrawItemDetailDrawItemRewardDetailData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoDrawItemDetailDrawItemRewardDetailData();

            if (data.hasOwnProperty('rewardNo')) {
                obj['rewardNo'] = ApiClient.convertToType(data['rewardNo'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('percent')) {
                obj['percent'] = ApiClient.convertToType(data['percent'], 'Number');
            }
            if (data.hasOwnProperty('purchaseCount')) {
                obj['purchaseCount'] = ApiClient.convertToType(data['purchaseCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoDrawItemDetailDrawItemRewardDetailData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoDrawItemDetailDrawItemRewardDetailData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} rewardNo
 */
EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.prototype['rewardNo'] = undefined;

/**
 * @member {Number} itemId
 */
EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.prototype['itemCount'] = undefined;

/**
 * @member {Number} percent
 */
EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.prototype['percent'] = undefined;

/**
 * @member {Number} purchaseCount
 */
EventsControllerDtoDrawItemDetailDrawItemRewardDetailData.prototype['purchaseCount'] = undefined;






export default EventsControllerDtoDrawItemDetailDrawItemRewardDetailData;

